import { Controller } from "web-ui/controller"

// Connects to data-controller="table-group"
export default class extends Controller {
  static targets = ["table"]

  static events = {
    "click tr.section-heading": "toggle"
  }

  toggle(event, heading) {
    // An actions cell rendered with no control, or a click that only reaches
    // its empty padding, still toggles the section like the rest of the
    // heading. Matched by content rather than by tag, so any control the
    // actions cell holds is covered without enumerating element types.
    // - Stephen, Thu Sep 10 2026
    if (event.target.closest(".actions-cell:has(.actions > *)")) {
      return
    }

    const section = heading.closest("table")

    this.setCollapsed(section, !section.hasAttribute("collapsed"))
  }

  collapseAll() {
    this.tableTargets.forEach((section) => this.setCollapsed(section, true))
  }

  expandAll() {
    this.tableTargets.forEach((section) => this.setCollapsed(section, false))
  }

  setCollapsed(section, collapsed) {
    section.toggleAttribute("collapsed", collapsed)

    const toggle = section.querySelector(".disclosure-toggle")
    toggle.setAttribute("aria-expanded", String(!collapsed))
  }
}
